import { RouteObject, createBrowserRouter } from 'react-router-dom';
import { withFaroRouterInstrumentation } from '@grafana/faro-react';

export const createBrowserRouterWithFaro = (routes: RouteObject[]) =>
  withFaroRouterInstrumentation(createBrowserRouter(routes));
